module.exports = __webpack_public_path__ + "img/img02.867d34ed.png";